import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import NominationForm from './NominationForm';
import ConfirmationView from './ConfirmationView';

export default function NominationPage() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <Container className="py-4" style={{ maxWidth: 800 }}>
      <PageHeader
        title="Recognise a Colleague"
        description="Nominate someone who has gone above and beyond our values."
        className="mb-4"
      />
      {submitted ? (
        <ConfirmationView onNominateAnother={() => setSubmitted(false)} />
      ) : (
        <NominationForm onSuccess={() => setSubmitted(true)} />
      )}
    </Container>
  );
}
